import {React , useEffect } from 'react';
import axios from 'axios';
import { useForm  } from 'react-hook-form';
import { useAuth } from '../../Context/AuthContext';
import { ToastContainer } from 'react-toastify';
import { useNavigate , useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Logo from '../../assets/images/logo.svg'
import Lock from '../../assets/images/lock.png'

export default function NewPassword() {
    const form = useForm();
    const {setNewPassword , isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const { search } = useLocation();

    const queryParams = new URLSearchParams(search);
    const tokenHash = queryParams.get('token_hash');

    const confirmToken = async (tokenHash) => {
        try {
            const response = await axios.post(
                'https://sydney-backend.vercel.app/auth/v1/confirm',
                {
                    payload: {
                        type: 'recovery', 
                        token_hash: tokenHash,
                    },
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.status === 200) {
                const { access_token } = response.data.data.session;
                localStorage.setItem('accessToken', access_token);
                navigate('/login'); // Redirect to login after successful reset
            }
        } catch (error) {
            console.error('Error confirming token:', error);
        }
    };

    useEffect(() => {
        if (tokenHash && !isAuthenticated) {
            confirmToken(tokenHash); 
        }
    }, [isAuthenticated, tokenHash]);

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = form;

    const password = watch('password', '');


    const onSubmit = async (data) => {
        const { password } = data;

        console.log('Data to send to API:', { password });

        let result = await setNewPassword({password});
        if (result) {
            navigate('/login');
        }

        
        form.reset();
    };

    



    return (
        <div className="Login-container">
            <div className="component-holder">
                <div className="filter">
                    <div className="header-holder">
                        <img className='logo' src={Logo} alt="logo" />
                        <p>Intelligent Heritage Explorer</p>
                    </div>
                    <div className='login-form'>
                        <form className='form-signup-holder' onSubmit={handleSubmit(onSubmit)} noValidate>
                                
                            <div className='input-holder-password'>
                                <label>Password</label>
                                <div className='input-with-icon'>
                                    <input
                                        type="password"
                                        placeholder="Enter your password"
                                        {...register("password", {
                                            required: true,
                                            validate: {
                                                checkLength: (value) => value.length >= 6,
                                                matchPattern: (value) =>
                                                    /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#_-|$*])/.test(
                                                        value
                                                    )
                                            }
                                        })}
                                    />
                                    <img
                                        src={Lock}
                                        alt="Lock"
                                        className="icon"
                                    />
                                    {errors.password && errors.password.type === "required" && (
                                        <p className="errorMsg">Password is required.</p>
                                    )}
                                    {errors.password && errors.password.type === "checkLength" && (
                                        <p className="errorMsg">
                                            Password should be at-least 10 characters.
                                        </p>
                                    )}
                                    {errors.password && errors.password.type === "matchPattern" && (
                                        <p className="errorMsg">
                                            Password must contain atleast Capital char and Specail char.
                                        </p>
                                    )}

                                </div>
                            </div>
                            <div className='input-holder-password'>
                                <label>Confirm Password</label>
                                <div className='input-with-icon'>
                                    <input
                                        type="password"
                                        placeholder="Enter your password"
                                        {...register("confirmPassword", {
                                            required: true,
                                            validate: value => value === password || "Passwords do not match"
                                        })}
                                    />
                                    <img
                                        src={Lock}
                                        alt="Lock"
                                        className="icon"
                                    />
                                    {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                                        <p className="errorMsg">Confirm password is required.</p>
                                    )}
                                    {errors.confirmPassword && errors.confirmPassword.type === "validate" && (
                                        <p className="errorMsg">Passwords do not match.</p>
                                    )}


                                </div>
                            </div>


                            <button className='login-button' type="submit" >Confirm</button>
                        </form>


                    </div>

                </div>

            </div>
            <ToastContainer
                                position="top-center"
                                autoClose={5000}
                                hideProgressBar={true}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="colored" />


        </div>
    )
}